import { render, staticRenderFns } from "./RatingAnswer.vue?vue&type=template&id=9d6334fc&scoped=true"
import script from "./RatingAnswer.vue?vue&type=script&lang=js"
export * from "./RatingAnswer.vue?vue&type=script&lang=js"
import style0 from "./RatingAnswer.vue?vue&type=style&index=0&id=9d6334fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6334fc",
  null
  
)

export default component.exports